import polyfills from './helpers/polyfills.js';

import {subscribe, publish} from './helpers/pubSub';
import {initMethods, initModules, initPages} from './helpers/utilities';
import detectFocusType from './components/detectFocusType';
import lazySizes from 'lazysizes';
import ShopTheLook from './components/shopTheLook.js';

import header from './components/header';
import * as miniCart from './components/miniCart';
import './components/customValidation';
import * as serviceWorkerEvents from './helpers/serviceWorkerEvents';

__webpack_public_path__ = `${window.SFRA.Urls.staticPath}js/`;

if (window.SFRA.SitePreferences.serviceWorkerCartridgeEnabled && window.SFRA.SitePreferences.enableServiceWorker && window.SFRA.ServiceWorkerPreference && window.SFRA.ServiceWorkerPreference.akamaiEnabled && 'serviceWorker' in navigator) {
    serviceWorkerEvents.init();
}

polyfills();

lazySizes.init();
detectFocusType();

initModules();
initPages();

header();
initMethods(miniCart.init);
if (window.SFRA.SitePreferences.enableShopTheLook) {
    ShopTheLook();
}

//Provide an easy way to initialize modules from a template.
//This is useful for setting up JS functionality for content that renders outside of our domain, like Einsten.
//`window.SFRA` is initially set in "/common/clientResources.isml", ensure it is picked up before adding a new property.
window.SFRA = window.SFRA || {};

window.SFRA.publish = publish;

subscribe('init:modules', initModules);
